
import React, {useState, useEffect} from 'react';
import { DataTable,TreeTable, Column, Skeleton } from 'primereact';
import {formatearNumero, formatearNumeroPorTipoExpresion} from "../../../Commons/Scripts/Utils/formatear";
import {useForm} from "../../../Commons/Scripts/Hooks/useForm";
import {UrlReporte, useImprimir} from "../../../Commons/Scripts/Hooks/useImprimir";
import {SimpleForm} from "../../../Commons/Scripts/Componentes/Form";
import {DateField} from "../../../Commons/Scripts/Componentes/DateField";
import {SelectField} from "../../../Commons/Scripts/Componentes/SelectField";
import {Button2} from "../../../Commons/Scripts/Componentes/Button";
import {Message, MessageProvider, useMessage} from "../../../Commons/Scripts/Componentes/Message";
import {hoy, primerDiaAnio} from "../Utils/fecha";
import {
  useExpresadoEnV2, useFuentesDocumentoV2, useObtenerCuentasV2, useObtenerDiarioRazonV2,
  useObtenerEstadoResultado,
  useObtenerEstadoResultadoComparativo, useObtenerMayorGeneral, useObtenerPeriodosContablesV2,
  useObtenerPeriodosFiscalesV2
} from "../Services/contabilidad-service";
import {MayorGeneral} from "./mayor-general";
import {OcultarCelda} from "./Common/OcultarCelda";
import {RadioButtonField} from "../../../Commons/Scripts/Componentes/RadioButtonField";

function Formulario({
  onSubmit,
  valorInicial = {},
  periodosContables,
  periodosFiscales,
  expresadosEn,
  onChange,
  compararPeriodosContables,
  where,
  whereComparativo,
}) {
  const form = useForm(valorInicial);

  const [modoCompracion, setModoCompracion] = useState("periodoFiscal");

  const [loadingPdf, handlePdf] = useImprimir(UrlReporte.ESTADO_RESULTADO, "PDF");
  const [loadingExcel, handleExcel] = useImprimir(UrlReporte.ESTADO_RESULTADO, "Excel");
  const [loadingCsv, handleCsv] = useImprimir(UrlReporte.ESTADO_RESULTADO, "CSV");

  useEffect(() => {
    if (expresadosEn) {
      form.setValue("expresadoEn", expresadosEn[0]);
    }
  }, [expresadosEn]);

  useEffect(() => {
    if (form?.values?.tipo === "comparativo") {
      if (!form.getValue("periodoFiscal") || form.getValue("periodoFiscal").value === -1) {
        form.setValue("periodoFiscal", periodosFiscales[periodosFiscales.length - 1]);
      }
    }
  }, [periodosFiscales, form.values.tipo]);

  useEffect(() => {
    if (form.getValue("periodoContable") && form.getValue("periodoContable").value !== -1) {
      setModoCompracion("periodoContable");
      form.setValue("comparar", undefined);
    } else {
      setModoCompracion("periodoFiscal");
      form.setValue("comparar", undefined);
    }
  }, [form.values.periodoContable]);

  const handleSubmit = () => {
    onSubmit(form.values);
  };

  const esComparativo = form.getValue("tipo") === "comparativo";

  return (
    <SimpleForm formulario={form} onChange={onChange}>
      {form.getValue("tipo") === "normal" && (
        <React.Fragment>
          <div className="row">
            <DateField name="fechaInicio" label="Fecha Inicio" mostrarIcono={true} />
            <DateField name="fechaFin" label="Fecha Fin" mostrarIcono={true} />
          </div>
        </React.Fragment>
      )}

      <div className="row">
        <SelectField
          name="periodoFiscal"
          opciones={periodosFiscales}
          placeholder="Seleccione un período fiscal"
          label="Periodo Fiscal"
          opcionPorDefecto={!esComparativo && true}
          width="250px"
        />
      </div>
      <div className="row">
        <SelectField
          name="periodoContable"
          opciones={periodosContables}
          placeholder="Seleccione un período contable"
          label="Periodo Contable"
          opcionPorDefecto={true}
          width="250px"
        />
      </div>
      <div className="row">
        <SelectField name="expresadoEn" opciones={expresadosEn} label="Expresado en" />
      </div>
      <div className="row">
        <label className="label">Tipo</label>
        <div className="control">
          <div style={{ display: "flex", alignItems: "center", gap: "0 5px" }}>
            <RadioButtonField name="tipo" label="Normal" value="normal" />
            <RadioButtonField name="tipo" label="Comparativo" value="comparativo" />
          </div>
        </div>
      </div>

      {form.getValue("tipo") === "comparativo" && modoCompracion === "periodoFiscal" && (
        <div className="row">
          <SelectField isMulti name="comparar" opciones={periodosFiscales} label="Períodos Comparación" width="300px" />
        </div>
      )}

      {form.getValue("tipo") === "comparativo" && modoCompracion === "periodoContable" && (
        <div className="row">
          <SelectField
            isMulti
            name="comparar"
            opciones={compararPeriodosContables}
            label="Períodos Comparación"
            width="300px"
          />
        </div>
      )}

      <div
        style={{
          display: "flex",
          gap: "0 5px",
          margin: "10px 0 10px 150px",
        }}
      >
        <Button2 texto="Buscar" onClick={handleSubmit} />
        <Button2
          texto="PDF"
          icono="imprimir"
          onClick={() => {
            if (form.values.tipo === "comparativo") {
              handlePdf({ TipoReporte: "comparativo", ...whereComparativo });
            } else {
              handlePdf({ ...where?.where });
            }
          }}
          loading={loadingPdf}
        />
        <Button2
          texto="Excel"
          icono="excel"
          onClick={() => {
            if (form.values.tipo === "comparativo") {
              handleExcel({ TipoReporte: "comparativo", ...whereComparativo });
            } else {
              handleExcel({ ...where?.where });
            }
          }}
          loading={loadingExcel}
        />
        <Button2
          texto="CSV"
          icono="excel"
          onClick={() => {
            if (form.values.tipo === "comparativo") {
              handleCsv({ TipoReporte: "comparativo", ...whereComparativo });
            } else {
              handleCsv({ ...where?.where });
            }
          }}
          loading={loadingCsv}
        />
      </div>
    </SimpleForm>
  );
}

function Tabla({ data, loading, expresado, handleFiltros }) {
  const [expandedKeys, setExpandedKeys] = useState({});

  const handleExpandir = (e) => {
    const clickedColumnIndex = e.originalEvent.target.cellIndex;

    if (clickedColumnIndex === 0) {
      const newExpandedKeys = { ...expandedKeys };
      if (newExpandedKeys[e.node.key]) {
        delete newExpandedKeys[e.node.key];
      } else {
        newExpandedKeys[e.node.key] = true;
      }
      setExpandedKeys(newExpandedKeys);
    }
  };

  const filtrar = (item) => {
    handleFiltros({
      Fuente: "ESTADO_RESULTADO",
      IdentificadorCuenta: item.data.IdentificadorCuenta,
    });
  };

  if (loading) {
    return (
      <DataTable showHeaders={false} value={Array.from({ length: 30 })}>
        <Column body={<Skeleton style={{ height: "40px" }} />} />
      </DataTable>
    );
  }

  return (
    <TreeTable
      id="grid"
      value={data}
      tableStyle={{ minWidth: "40rem" }}
      expandedKeys={expandedKeys}
      onToggle={(e) => setExpandedKeys(e.value)}
      onRowClick={handleExpandir}
      rowClassName={(item) => {
        return {
          "total-row": item.data.IdentificadorCuenta === "Total",
          "subtotal-row": item.data.IdentificadorCuenta === "Subtotal",
        };
      }}
      emptyMessage="No se han encontrado resultados"
    >
      <Column field="CuentaDesc" style={{ width: "75%", cursor: "pointer" }} expander={() => ({ className: "red" })} />

      <Column
        header="Balance"
        style={{ textAlign: "right" }}
        body={(item) => {
          const balance = item.data?.BalancePeriodoActual ?? 0;

          const identificadorCuenta = item.data?.IdentificadorCuenta;
          const esIdentificadorCuentaNoValido =
            identificadorCuenta === "0" || identificadorCuenta === "1" || identificadorCuenta === "5";

          const numeroFormateado = formatearNumero(formatearNumeroPorTipoExpresion(Math.abs(balance), expresado));
          const resultadoFinal = balance < 0 ? `(${numeroFormateado})` : numeroFormateado;

          const esTotal = item.data.IdentificadorCuenta === "Total" || item.data.IdentificadorCuenta === "Subtotal";
          const clases = `${balance < 0 ? "text-red" : ""} ${!esTotal && !esIdentificadorCuentaNoValido ? "link" : ""}`;

          return (
            <OcultarCelda item={item} expandedKeys={expandedKeys}>
              <div
                style={{ width: "100%" }}
                onClick={() => {
                  if (!esTotal && !esIdentificadorCuentaNoValido) {
                    filtrar(item);
                  }
                }}
                className={clases}
              >
                {resultadoFinal}
              </div>
            </OcultarCelda>
          );
        }}
      />
    </TreeTable>
  );
}

function TablaComparativo({ data, columnas, loading, expresado, handleFiltros }) {
  const [expandedKeys, setExpandedKeys] = React.useState({});

  const handleExpandir = (e) => {
    const clickedColumnIndex = e.originalEvent.target.cellIndex;

    if (clickedColumnIndex === 0) {
      const newExpandedKeys = { ...expandedKeys };
      if (newExpandedKeys[e.node.key]) {
        delete newExpandedKeys[e.node.key];
      } else {
        newExpandedKeys[e.node.key] = true;
      }
      setExpandedKeys(newExpandedKeys);
    }
  };

  const filtros = (item) => {
    handleFiltros({
      IdentificadorCuenta: item.data.IdentificadorCuenta,
    });
  };

  return (
    <div>
      <TreeTable
        value={data}
        tableStyle={{ minWidth: "40rem" }}
        loading={loading}
        expandedKeys={expandedKeys}
        onToggle={(e) => setExpandedKeys(e.value)}
        onRowClick={handleExpandir}
        rowClassName={(item) => {
          return {
            "total-row": item.data.IdentificadorCuenta === "Total",
            "subtotal-row": item.data.IdentificadorCuenta === "Subtotal",
          };
        }}
      >
        <Column
          header="Cuentas"
          body={(item) => {
            return (
              <span
                onClick={(e) => {
                  const thElement = e.target.closest("td");
                  if (thElement) {
                    thElement.click();
                  }
                }}
              >
                {item.data.CuentaDesc}
              </span>
            );
          }}
          style={{ width: "450px", cursor: "pointer" }}
          expander
        />
        {columnas?.map((columna, index) => {
          return (
            <Column
              style={{ width: "200px", textAlign: "right" }}
              key={`${index}-${columna}`}
              header={columna}
              body={(item) => {
                const balance = item.data[`Balance${index}`];

                const numeroFormateado = formatearNumero(formatearNumeroPorTipoExpresion(Math.abs(balance), expresado));
                const resultadoFinal = balance < 0 ? `(${numeroFormateado})` : numeroFormateado;

                return (
                  <OcultarCelda item={item} expandedKeys={expandedKeys}>
                    <span className={balance < 0 ? "text-red" : ""}>{resultadoFinal}</span>
                  </OcultarCelda>
                );
              }}
              columnKey={`balance_${index}`}
            />
          );
        })}
      </TreeTable>
    </div>
  );
}

export function EstadoResultado() {
  const { messages, typeMessages, handleException } = useMessage();
  const [tab, setTab] = useState("ESTADO_RESULTADO");

  const isEstadoResultado = tab === "ESTADO_RESULTADO";
  const isMayorGeneral = tab === "MAYOR_GENERAL";

  const [where, setWhere] = useState({
    where: {
      FechaInicio: primerDiaAnio,
      FechaFin: hoy,
      ExpresadoEn: "D",
    },
  });
  const [whereComparativo, setWhereComparativo] = useState();
  const [whereMayorGeneral, setWhereMayorGeneral] = useState({
    where: {
      FechaInicio: primerDiaAnio,
      FechaFin: hoy,
      ExpresadoEn: "D",
    },
  });
  const [wherePeriodoContable, setWherePeriodoContable] = useState();

  const { data, loading, error } = useObtenerEstadoResultado(where);
  const {
    data: dataComparativo,
    columnas,
    loading: loadingComparativo,
  } = useObtenerEstadoResultadoComparativo(whereComparativo);

  const { data: periodosFiscales } = useObtenerPeriodosFiscalesV2();
  const { data: periodosContables } = useObtenerPeriodosContablesV2(wherePeriodoContable);
  const { data: expresadosEn } = useExpresadoEnV2();

  const { data: compararPeriodosContables } = useObtenerPeriodosContablesV2();

  const [tipo, setTipo] = React.useState("normal");
  const [expresado, setExpresado] = React.useState(null);

  /* mayor general */
  const [wherePeriodoContableMG, setWherePeriodoContableMG] = React.useState();

  const { data: periodosContablesMG } = useObtenerPeriodosContablesV2(wherePeriodoContableMG);
  const { data: cuentas } = useObtenerCuentasV2();
  const { data: fuentesDocumento } = useFuentesDocumentoV2();
  const { data: razones } = useObtenerDiarioRazonV2();
  const {
    data: dataMayorGeneral,
    loading: loadingMayorGeneral,
    error: errorMayorGeneral,
  } = useObtenerMayorGeneral(whereMayorGeneral);

  /* mayor general*/
  const [filtros, setFiltros] = useState({});
  const [filtro, setFiltro] = useState(false);

  const handleOnChangeFormulario = (formulario) => {
    if (formulario.tipo) {
      setTipo(formulario.tipo);
    }
    if (formulario.expresadoEn) {
      setExpresado(formulario.expresadoEn?.value);
    }
    if (formulario.periodoFiscal) {
      setWherePeriodoContable({
        PeriodoFiscalIdSec: formulario.periodoFiscal?.value,
      });
    }
    if (formulario.tipo === "detalle") {
      setWhere({ ...where, ReporteTipo: formulario.tipo });
    } else if (where?.ReporteTipo === "detalle") {
      setWhere({ ...where, ReporteTipo: formulario.tipo });
    }
    if (formulario.fechaInicio && formulario.fechaFin) {
      setFiltros({
        FechaInicio: formulario.fechaInicio,
        FechaFin: formulario.fechaFin,
      });
    }
  };

  /* mayor general */
  const handleOnChangeFormularioMG = (formulario) => {
    if (formulario.cuenta && filtros?.IdentificadorCuenta && !filtro) {
      setWhereMayorGeneral({
        where: {
          FechaInicio: formulario.fechaInicio,
          FechaFin: formulario.fechaFin,
          PeriodoFiscalIdSec: formulario.periodoFiscal?.value,
          PeriodoContableIdSec: formulario.periodoContable?.value,
          TipoDocumentoIdSec: formulario.tipoDocumento?.value,
          CuentasIdentificadorLista: formulario.cuenta?.map((item) => item.value),
          SinMovimiento: formulario.sinMovimiento,
        },
      });
      setFiltro(true);
    }
  };

  const handleSubmitMG = (formulario) => {
    setWhereMayorGeneral({
      where: {
        FechaInicio: formulario.fechaInicio,
        FechaFin: formulario.fechaFin,
        PeriodoFiscalIdSec: formulario.periodoFiscal?.value,
        PeriodoContableIdSec: formulario.periodoContable?.value,
        TipoDocumentoIdSec: formulario.tipoDocumento?.value,
        CuentasIdentificadorLista: formulario.cuenta?.map((item) => item.value),
        SinMovimiento: formulario.sinMovimiento,
      },
    });
    setFiltro(false);
  };

  /* mayor general */
  const handleFiltros = (filtro) => {
    setTab("MAYOR_GENERAL");
    setFiltros((prevState) => ({ ...prevState, ...filtro }));
    setFiltro(false);
  };

  useEffect(() => {
    if (error) {
      handleException(error);
    }
    if (errorMayorGeneral) {
      handleException({
        error: errorMayorGeneral,
      });
    }
  }, [error, errorMayorGeneral]);

  return (
    <React.Fragment>
      <div className={isEstadoResultado ? "" : "hidden"}>
        <div>
          <Message messages={messages} type={typeMessages} />
          <Formulario
            onSubmit={(formulario) => {
              if (formulario.tipo === "comparativo") {
                if (formulario.periodoContable && formulario.periodoContable.value !== -1) {
                  setWhereComparativo({
                    PeriodoContableInicioIdSec: formulario.periodoContable?.value,
                    PeriodosContablesComparativoIdSec: formulario.comparar?.map((c) => c.value),
                    ExpresadoEn: formulario.expresadoEn?.value,
                  });
                } else {
                  setWhereComparativo({
                    PeriodoFiscalInicioIdSec: formulario.periodoFiscal?.value,
                    PeriodosFiscalesComparativoIdSec: formulario.comparar?.map((c) => c.value),
                    ExpresadoEn: formulario.expresadoEn?.value,
                  });
                }
              } else {
                setWhere({
                  where: {
                    FechaInicio: formulario?.fechaInicio,
                    FechaFin: formulario?.fechaFin,
                    PeriodoFiscalInicioIdSec: formulario.periodoFiscal?.value,
                    PeriodoContableInicioIdSec: formulario.periodoContable?.value,
                    ExpresadoEn: formulario.expresadoEn?.value,
                  },
                });
              }
            }}
            valorInicial={{
              fechaInicio: primerDiaAnio,
              fechaFin: hoy,
              tipo: "normal",
            }}
            periodosContables={periodosContables}
            periodosFiscales={periodosFiscales}
            compararPeriodosContables={compararPeriodosContables}
            expresadosEn={expresadosEn}
            onChange={handleOnChangeFormulario}
            where={where}
            whereComparativo={whereComparativo}
          />
        </div>

        <br />
        <br />
        <div className="inMenu">
          <div className="inMenuItem">
            <span
              className={isEstadoResultado ? "subTitle" : "linkSubtitulo"}
              onClick={() => setTab("ESTADO_RESULTADO")}
            >
              Estado Resultado
            </span>
          </div>
          <div className="inMenuItem">|</div>
          <div className="inMenuItem">
            <span className={isMayorGeneral ? "subTitle" : "linkSubtitulo"} onClick={() => setTab("MAYOR_GENERAL")}>
              Mayor General
            </span>
          </div>
          <div className="fix"></div>
        </div>
        <br />

        {tipo === "normal" && (
          <Tabla data={data} loading={loading} expresado={expresado} handleFiltros={handleFiltros} />
        )}
        {tipo === "comparativo" && (
          <TablaComparativo
            data={dataComparativo}
            columnas={columnas}
            loading={loadingComparativo}
            expresado={expresado}
            handleFiltros={handleFiltros}
          />
        )}
      </div>
      <div className={isMayorGeneral ? "" : "hidden"}>
        <MayorGeneral
          handleSubmitMG={handleSubmitMG}
          periodosContablesMG={periodosContablesMG}
          periodosFiscales={periodosFiscales}
          expresadosEn={expresadosEn}
          cuentas={cuentas}
          fuentesDocumento={fuentesDocumento}
          razones={razones}
          handleOnChangeFormularioMG={handleOnChangeFormularioMG}
          filtros={filtros}
          filtro={filtro}
          data={dataMayorGeneral}
          loading={loadingMayorGeneral}
          where={whereMayorGeneral}
          isEstadoResultado={isEstadoResultado}
          isMayorGeneral={isMayorGeneral}
          setTab={setTab}
        />
      </div>
    </React.Fragment>
  );
}
